import profileRequest from '@stelecom/ui-react/components/requests/profileRequestIntegration';

export enum EConnectionType {
    PPPoE,
    IPoE_domru,
    DHCP_mac_vlan_static,
    DHCP_mac_vlan,
    DHCP_option_82,
    L2TP,
    PPTP
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function getConnectionType(domain: string, accessToken: string): Promise<EConnectionType> {
    const axiosInstance = profileRequest(domain, accessToken);
    const resp = await axiosInstance.post('/services-settings/connection-type');
    return resp.data;
}
